@if (isBannerVisible && offersEligible && !offerAccepted) {
    <article appBannerObserver (bannerVisible)="onBannerDisplayed()" class="d-flex flex-column flex-md-row align-items-center bg-white p-4 position-relative">
        <div class="d-flex align-items-start">
            <img src="assets/icons/confirmation-positive-green.png" alt="" class="img-fluid" style="width: 30px; height: auto; margin-right: 5px;">
            <div class="d-flex flex-column">
                <p class="mb-0 top-text">
                    {{ "accountOverview.offerEligibility.topBannerInfo" | cxTranslate }}
                </p>
                <p class="mb-0">
                    {{ "accountOverview.offerEligibility.topBannerInfo2" | cxTranslate }}
                </p>
            </div>
        </div>

        <a (click)="onViewOffer()" class="btn-secondary ml-md-auto display-block">{{ "accountOverview.offerEligibility.topBannerButton" | cxTranslate }}</a>

        <button class="border-0 bg-transparent p-0 position-absolute obc-close" aria-label="close offers banner" (click)="closeBanner()">
            <span aria-hidden="true">&times;</span>
        </button>
    </article>
}
